import React, { useState } from "react"
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Box from "@material-ui/core/Box";



export const PopoverCell = ({ data }: { data: string[] }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      popover: {
        pointerEvents: 'none',
      }
    }),
  );

  const classes = useStyles();

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  if (data.length > 1) {

    return(
      <Box width="100%">
          <Typography
              align="left"
              aria-owns={open ? 'mouse-over-popover' : undefined}
              aria-haspopup="true"
              onMouseEnter={handlePopoverOpen}
              onMouseLeave={handlePopoverClose}
          >
            <MoreHorizIcon />
          </Typography>
          <Popover
              id="mouse-over-popover"
              className={classes.popover}
              open={open}
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              onClose={handlePopoverClose}
              disableRestoreFocus
          >
            <List>
                {data.map(item => 
                    <ListItem>
                        <ListItemText primary={item} />
                    </ListItem>
                )}
            </List>
          </Popover>
      </Box>
  )
  } else {
    return(<span>{data[0]}</span>)
  }
}